import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Text } from 'foundations-components/components/Text';
import QualifiedLeadsHistoryPanel from './QualifiedLeadsHistoryPanel';
import { HANDOFF_TYPES } from './constants';
import { getSubmissionBriefsForCompanyByContact } from './utils/api/QualifiedLeadsApi';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function renderSubmission(submission) {
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: submission.submittedAt,
        format: "ll"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "200",
      as: "span",
      children: HANDOFF_TYPES[submission.handoffType]
    })]
  }, submission.id);
}
function renderSubmissions(contactVid, submissions) {
  const submissionsForContact = submissions.filter(submission => String(submission.contact.vid) === String(contactVid));
  return submissionsForContact.length ? /*#__PURE__*/_jsx(List, {
    marginBlockEnd: "400",
    wrapChildren: true,
    children: submissionsForContact.sort((a, b) => b.submittedAt - a.submittedAt).slice(0, 3).map(renderSubmission)
  }) : null;
}
function renderViewHistoryLink(isPanelOpen, setPanelOpen) {
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    justify: "center",
    direction: "row",
    wrap: "wrap",
    children: /*#__PURE__*/_jsx(Link, {
      disabled: isPanelOpen,
      onClick: () => setPanelOpen(true),
      children: "View full history"
    })
  });
}
function QualifiedLeadsList(props) {
  const [isLoading, setLoading] = useState(false);
  const [isPanelOpen, setPanelOpen] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const fetchSubmissions = contactVid => {
    setLoading(true);
    getSubmissionBriefsForCompanyByContact(contactVid).then(result => {
      setLoading(false);
      setSubmissions(result);
    }, __ => {
      setLoading(false);
      setSubmissions([]);
    }).catch(console.log);
  };
  useEffect(() => fetchSubmissions(props.contactVid), [props.contactVid]);
  useEffect(() => {
    const handleWindowEvents = event => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const {
        data
      } = event;
      if (!data.payload || `${data.payload.leadContactVid}` !== `${props.contactVid}`) {
        return;
      }
      switch (data.type) {
        case 'QL_PANEL_DOMAIN_EDITED':
        case 'QL_PANEL_SUBMISSION_CREATED':
          fetchSubmissions(props.contactVid);
          break;
        default:
          break;
      }
    };
    window.addEventListener('message', handleWindowEvents, false);
    return () => {
      window.removeEventListener('message', handleWindowEvents);
    };
  }, [props.contactVid]);
  return isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
    label: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      children: "Loading history"
    }),
    minHeight: 32,
    showLabel: true,
    size: "small"
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [submissions.length ? /*#__PURE__*/_jsxs(View, {
      paddingBlock: "100",
      as: "div",
      children: [renderSubmissions(props.contactVid, submissions), renderViewHistoryLink(isPanelOpen, setPanelOpen)]
    }) : /*#__PURE__*/_jsx(View, {
      paddingBlock: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        children: "No leads have been raised yet."
      })
    }), isPanelOpen && /*#__PURE__*/_jsx(QualifiedLeadsHistoryPanel, {
      onClose: () => setPanelOpen(false),
      submissions: submissions
    })]
  });
}
QualifiedLeadsList.propTypes = {
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default QualifiedLeadsList;